import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Toast from 'components/Toast';
import StorageHandler from 'config/StorageHandler';

import parse from 'html-react-parser';
import { storageKeys } from 'config/settings.json';

export default class FillBlanks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blanksContent: ['', '', ''],
      correctAnswers: 0,
      question: '',
      toastContent: null,
      headerImage: '',
    };

  }

  componentDidMount() {
    this.parseText();
    this.setHeader();
  }

  componentDidUpdate(prevProps) {
    const { quizMode, quizTimerExpired, error } = this.props;
    if (quizMode && quizTimerExpired && !prevProps.quizTimerExpired) {
      setTimeout(() => error(true), 600);
    }
    if (!prevProps.completedBefore && this.props.completedBefore) {
      // Prefill and disable inputs if completion status flips to true after mount
      const { answer, contentComplete } = this.props;
      answer.forEach((a, i) => {
        const input = document.getElementById(`fitb_input_${i}`);
        if (input) {
          input.value = a;
          input.setAttribute('value', a);
          input.setAttribute('placeholder', a);
          input.disabled = true;
        }
      });
      contentComplete();
    }
  }

  async setHeader() {
    // Load profile image image
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ headerImage: questionHeader });
  }

  checkAnswer(i) {
    const { answer } = this.props;
    const { blanksContent } = this.state;
    return answer[i].toLowerCase() === blanksContent[i];
  }

  parseText() {
    const { answer, contentComplete, correctAnswerText, question } = this.props;

    let newQuestion = question;
    answer.forEach((a, i) => {
      const blankMatch = new RegExp(/\[blank[^[\]]*]/);

      const input = `<input
        id="fitb_input_${i}"
        class="input__fitb"
         autocomplete="new-password"
        ${i === 0 ? 'autofocus=1' : ''}
        maxlength="${a.length}"
        size="${a.length}"
        tabindex="${i}"
      />`;

      newQuestion = newQuestion.replace(blankMatch, input);
    });
    this.setState({ question: parse(newQuestion) }, () => {
      answer.forEach((a, i) => {
        const input = document.getElementById(`fitb_input_${i}`);
        input.addEventListener('input', (e) => {
          const { blanksContent, correctAnswers } = this.state;
          const newContent = blanksContent;
          newContent[i] = e.target.value.toLowerCase();

          this.setState({ blanksContent: newContent }, () => {
            if (this.checkAnswer(i)) {
              input.disabled = true;
              if (correctAnswers < answer.length - 1) {
                this.setState({ correctAnswers: correctAnswers + 1 });
                document.getElementById(`fitb_input_${i < answer.length - 1 ? i + 1 : i}`).focus();
              } else {
                this.setState({
                  toastContent: {
                    type: 'success',
                    position: 'top-center',
                    content: correctAnswerText,
                  },
                });
                contentComplete();
              }
            }
          });
        });
      });
    });
  }

  render() {
    const { question, toastContent, headerImage } = this.state;
    const { disableHeader, disableToast, quizMode } = this.props;
    return (
      <div className={clsx('container__question', { 'quiz-mode-card': quizMode })}>
        {!disableHeader && (
          <div className="container__question--image" style={{ backgroundImage: `url(${headerImage})` }} />
        )}
        <div className="container__question--content fillBlanks">
          <h4>{question}</h4>
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
        </div>
        {this.props.error(false)}
        {this.props.correct(false)}
      </div>
    );
  }
}


FillBlanks.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentComplete: PropTypes.func.isRequired,
  correct: PropTypes.func,
  correctAnswerText: PropTypes.string.isRequired,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  question: PropTypes.string.isRequired,
  title: PropTypes.string,
  disableToast: PropTypes.bool,
  quizMode: PropTypes.bool,
  quizTimerExpired: PropTypes.bool,
};

FillBlanks.defaultProps = {
  correct: () => undefined,
  disableHeader: false,
  error: () => undefined,
  title: null,
  disableToast: false,
  quizMode: false,
  quizTimerExpired: false,
};
